export default __webpack_public_path__ + "static/gallery-objects-f73a3f0963ec593748c69e86068fd862.mp4";